import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetPromotionById(club, id) {
  var url = "/reservation/get_promotion/" + club + "/" + id;

  return FetchGetDataWithAuthNEW(url);
}
